<template>
  <div id="projectDiv">
    <p>{{project_item.title}}</p>
    <table id="upperProjTable">
      <tr>
        <div>
          <td><p id="textTitle">Text Title:</p></td>
          <td><p id="textInsert">{{project_item.text_title}}</p></td>
        </div>
      </tr>
      <tr>
        <div>
          <td><p id="eventFields">Event Fields:</p></td>
        </div>
      </tr>
    </table>
      <div>
      <table id="innerTable">
        <div>
          <tr><p id="eventName">Event Name</p></tr>
        </div>
        <div>
          <tr>
            <td><p id="startDate">Start Date</p></td>
            <td><p id="endDate">End Date</p></td>
            <td><p id="endDate">Duration</p></td>
          </tr>

        </div>
        <div>
          <td><li id="list" v-for="field_name in project_item.field_names" v-bind:key="field_name">
            {{field_name}}
          </li></td>
        </div>
      </table>
        </div>
      <table id="lowerProjTable">
        <div>
          <td><p id="guidingQuestion" >Guiding Question:</p></td>
        </div>
        <tr>
          <td><p id="questionInsert"> {{project_item.guiding_question}}</p></td>
        </tr>
      <tr>
        <div>
        <td><router-link :to="project_item.uuid" tag="button" id="projLinkButton">Project Link</router-link></td>
        <!-- TODO: show edit and delete buttons only if the users owns the project -->
        <td style="text-align: left;"><input id="editButton" type="submit" v-on:click="editProject" value="Edit Project" class="button"/></td>
        <td><input id="deleteButton" type="submit" v-on:click="deleteProject" value="Delete Project" class="button"/></td>
        </div>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'Project',
  props: ["project_item"],
  methods: {
    editProject() {
      this.$emit('edit-project', this.project_item.uuid);
    },
    deleteProject() {
      this.$emit('delete-project', this.project_item.id);
    }
  }
}
</script>
<style scoped>

#projectDiv{
  margin-left: 35%;
  margin-right: 35%;
  background-color: #d9d9d9;
  border: 8px solid #f7f7f7;
  min-width: 300px;
}

#upperProjTable, #lowerProjTable{
  margin-left: auto;
  margin-right: auto;
  text-align: left;
}

#projectTitle{
  font-size: large;
  font-weight: bold;
  margin: 8px;
}

#textTitle{
  font-weight: bold;
  float: left; margin:
  4px; margin-left: 16px;
}

#textInsert{
  font-weight: 500;
  float: left; margin: 4px;
  margin-left: 16px;
}

#eventFields{
  font-weight: bold;
  margin: 8px;

}

#list{
  font-weight: 500;
  list-style-type: none
}

#guidingQuestion{
  font-weight: bold;
  margin: 8px;
  margin-left: 16px;
  margin-right: 0px;
}

#questionInsert{
  font-weight: 500;
  margin: 8px;
  margin-left: 16px;
}

#editButton{
  display: inline-block;
  margin: 8px;

}

#projLinkButton, #editButton, #deleteButton {
  background-color: var(--block-orange);
  font-family: system-ui, sans-serif;
  font-weight: 600;
  border-radius: 2px;
  margin-top: 10px;
  border: none;
  font-size: small;
  padding: 5px;
  cursor: pointer;
}

#editButton.button:hover, #projLinkButton.button:hover, #deleteButton.button:hover  {
  cursor: pointer;
}

#innerTable{
  background-color: var(--form-blue);
  margin-left: auto;
  margin-right: auto;
  text-align: left;
}

#eventName, #endDate, #startDate, #list{
  margin-top: 4px;
  margin-bottom: 4px;
  color: white;
  margin-left: 4px;
  font-weight: 500;
}

#endDate{
  margin-left: 8px;
}
</style>
